export default __webpack_public_path__ + "static/media/QSTL Team Details.b2658f9b.pdf";